import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPin24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPin24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m15.1 11.99-.53.358-.107.63-.635 3.725a.501.501 0 0 1-.847.27l-5.993-5.977a.499.499 0 0 1 .27-.845l3.736-.633.63-.106.36-.528 2.72-3.989a1.003 1.003 0 0 1 1.537-.144l3.003 2.995a.997.997 0 0 1-.145 1.531zM7.005 8.674l3.736-.632 2.72-3.989a2.508 2.508 0 0 1 3.84-.361l3.004 2.994a2.492 2.492 0 0 1-.362 3.83l-4 2.712-.635 3.726c-.272 1.598-2.24 2.224-3.39 1.077l-2.455-2.447-.011.01-5.18 5.166a.753.753 0 0 1-1.062 0 .747.747 0 0 1 0-1.06l5.18-5.164.01-.011-2.476-2.47c-1.15-1.146-.522-3.11 1.081-3.38"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPin24);
